import React from 'react'
import { keyframes } from '@emotion/react'
import { Box } from '../'
import { BoxProps } from '../'

// cribbed from ThemeUI Spinner
// https://github.com/system-ui/theme-ui/blob/develop/packages/components/src/Spinner.js

// animation from
// https://loading.io/css/

const animation1 = keyframes({
    from: {
        transform: 'scale(0)'
    },
    to: {
        transform: 'scale(1)'
    }
})

const animation3 = keyframes({
    from: {
        transform: 'scale(1)'
    },
    to: {
        transform: 'scale(0)'
    }
})

const animation2 = keyframes({
    from: {
        transform: 'translate(0, 0)'
    },
    to: {
        transform: 'translate(14px, 0)'
    }
})

const Dot = (props: BoxProps) => (
    <Box
        sx={{
            position: 'absolute',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            animationTimingFunction: 'cubic-bezier(0, 1, 1, 0)',
            bg: props.color,
            ...props.sx
        }}
    />
)

// Sizes hardcoded because this is
// more like an image than a scalable element
export const Spinner = function (props: BoxProps) {
    return (
        <Box
            {...props}
            role="img"
            sx={{
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...props.sx
            }}
        >
            <Box
                sx={{
                    width: 7,
                    height: 2,
                    position: 'relative'
                }}
            >
                <Dot
                    sx={{
                        left: '4px',
                        animation: `${animation1} 0.6s infinite`
                    }}
                    color={(props.color as string) || 'primary'}
                />
                <Dot
                    sx={{
                        left: '4px',
                        animation: `${animation2} 0.6s infinite`
                    }}
                    color={(props.color as string) || 'primary'}
                />
                <Dot
                    sx={{
                        left: '19px',
                        animation: `${animation2} 0.6s infinite`
                    }}
                    color={(props.color as string) || 'primary'}
                />
                <Dot
                    sx={{
                        left: '33px',
                        animation: `${animation3} 0.6s infinite`
                    }}
                    color={(props.color as string) || 'primary'}
                />
            </Box>
        </Box>
    )
}
